// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Sp\u00e4\u0165 na hlavn\u00fa str\u00e1nku";
export const WIKI_REVIEWS_SEARCH = "H\u013eadaj";
export const WIKI_REVIEWS_SEARCH_PLACEHOLDER = "H\u013eadaj produkt...";
export const WIKI_REVIEWS_SEARCH_RESULT_query_count = ["%(count)s produkt pre \"%(query)s\" v Centre recenzi\u00ed", "%(count)s produkty pre \"%(query)s\" v Centre recenzi\u00ed", "%(count)s produktov pre \"%(query)s\" v Centre recenzi\u00ed"];
